<template>
  <div class="footer" :class="{ policy_footer: hasPolicyFooter }">
    <div v-if="hasPolicyFooter && userRegion !== 'jppc'" class="policy">
      <a :href="policyLink.termsOfUse" target="_blank">{{ $t('footer.useOfTerms') }}</a>
      <span class="line">|</span>
      <a :href="policyLink.userPrivacy" target="_blank" class="user_policy">{{ $t('footer.userPolicy') }}</a>
    </div>
    <div v-if="hasPolicyFooter && userRegion === 'jppc'" class="policy ja">
      <a :href="policyLink.termsOfUse" target="_blank">{{ $t('footer.operationPolicy') }}</a>
    </div>
    <p class="copyright" :class="{ copyright_policy: hasPolicyFooter }">
      {{
        userRegion === 'jppc'
          ? '© NEXON Korea Corporation & NEXON Co., Ltd All Rights Reserved.'
          : '© NEXON Korea Corporation All Rights Reserved.'
      }}
    </p>
    <div class="language_wrapper" @click="toggleLanguageMenu">
      <button class="button_language" :class="{ lang_policy: hasPolicyFooter }">
        <i class="icon_globe" />
        <span>{{ languageList[selectedLocaleIdx].name }}</span>
        <i class="icon_chevron_close" :class="{ open: isLanguageMenuOpen }" />
      </button>
      <div v-if="isLanguageMenuOpen" class="wrapper_language_list">
        <ul>
          <li
            v-for="lang in languageList"
            :key="lang.code"
            :value="lang"
            class="sub_menu"
            @click="changeLocale(lang.code)"
          >
            {{ lang.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import { checkUserRegion } from '@/utils';

export default {
  data() {
    return {
      isLanguageMenuOpen: false,
      languageList: [
        {
          code: 'en',
          name: 'English',
        },
        {
          code: 'ko',
          name: '한국어',
        },
        {
          code: 'zh',
          name: '繁體中文',
        },
        {
          code: 'ja',
          name: '日本語',
        },
      ],
    };
  },
  computed: {
    userRegion() {
      return checkUserRegion();
    },
    selectedLocaleIdx() {
      return this.languageList.findIndex((langItem) => langItem.code === this.$i18n.locale);
    },
    hasPolicyFooter() {
      return this.userRegion === 'krpc' || this.userRegion === 'jppc';
    },
    policyLink() {
      return {
        termsOfUse:
          this.userRegion === 'jppc'
            ? 'https://m.nexon.com/terms/848'
            : 'https://member.nexon.com/policy/stipulation.aspx',
        userPrivacy:
          this.userRegion === 'jppc'
            ? 'https://company.nexon.co.jp/support/privacypolicy.html'
            : 'https://member.nexon.com/policy/privacy.aspx',
      };
    },
  },
  created() {
    this.isLanguageMenuOpen = false;
  },
  methods: {
    toggleLanguageMenu() {
      this.isLanguageMenuOpen = !this.isLanguageMenuOpen;
    },
    changeLocale(locale) {
      if (locale === this.$i18n.locale) return;
      this.$root.$i18n.locale = locale;

      router.replace({
        path: `/${locale}${this.$route.fullPath.substring(3)}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.policy_footer {
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}
.policy {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  .line {
    color: #ddd;
  }
  a {
    font-family: 'Noto Sans KR';
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.26px;
    color: #666;
  }
  .user_policy {
    color: #333;
    font-weight: bold;
  }
  &.ja {
    a {
      font-family: 'Noto Sans JP', 'Helvetica Neue', Arial, 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Meiryo,
        sans-serif;
    }
  }
}
.copyright {
  &.copyright_policy {
    margin-top: 0;
  }
}
.language_wrapper {
  display: flex;
  justify-content: center;
  position: relative;
}
.button_language {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-top: 12px;
  background-color: transparent;
  color: #111;
  font-family: 'Malgun Gothic', Arial, sans-serif;
  height: 13px;
  font-size: 12px;
  line-height: 13px;
  font-weight: 400;
  &.lang_policy {
    margin-top: 0;
  }
}
.wrapper_language_list {
  display: flex;
  flex-direction: column;
  width: 80px;
  height: 140px;
  position: absolute;
  bottom: 25px;
  z-index: 50;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  .sub_menu {
    padding: 11px 0;
    text-align: center;
    font-family: 'Malgun Gothic';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 13px;
    cursor: pointer;
    &:hover {
      background: #fafafa;
    }
  }
}
.icon_globe {
  background: url('~@/assets/images/icon_globe.svg') no-repeat 0 0;
  width: 16px;
  height: 16px;
  margin-right: 7px;
}
.icon_chevron_close {
  background: url('~@/assets/images/icon_chevron_black.svg') no-repeat 0 0;
  display: block;
  background-size: contain;
  width: 10px;
  height: 7px;
  margin-left: 5px;
  &.open {
    transform: rotate(180deg);
    margin-bottom: 3px;
  }
}
</style>
